var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.615.818A3 3 0 0 0 2.84 2.682L.223 9.076C.077 9.436 0 9.822 0 10.212v11.606a1 1 0 0 0 2 0v-3h20v3a1 1 0 0 0 2 0V10.212c0-.39-.076-.777-.223-1.136l-2.615-6.394A3 3 0 0 0 18.385.818zm15.896 8-2.2-5.378-16.472-.758 1.85.758-2.2 5.378zm.49 2H2v6h20zm-17 1.99a1 1 0 0 1 1 1v.01a1 1 0 0 1-2 0v-.01a1 1 0 0 1 1-1m14 0a1 1 0 0 1 1 1v.01a1 1 0 0 1-2 0v-.01a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};
export default SvgCar;